export const DEFAULT_TOOLTIP_WIDTH_MOBILE = 170;
export const DEFAULT_TOOLTIP_WIDTH_DESKTOP = 290;
export const DEFAULT_INFO_MARK_WIDTH = 16;

export const DEFAULT_TOOLTIP_TEXT_ALIGN = 'center';
